module.exports = __webpack_public_path__ + "img/LiBeirut1122.f15bbef6.jpeg";